import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { CSSProperties } from 'react';

interface Column {
  field: string;
  headerName: string | React.ReactNode;
  alignSelf?: 'left' | 'center' | 'right';
  customHeaderStyle?: CSSProperties;
  width?: number;
  customCellStyle?: CSSProperties;
}

interface PricingTableProps {
  mainHeaderName?: string;
  columns: Column[];
  data: any[];
  renderCell?: (row: any, column: any) => React.ReactNode;
}

const PricingTable = ({ mainHeaderName, renderCell, data, columns }: PricingTableProps) => {
  return (
    <TableContainer sx={{ maxHeight: '42rem' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={57} sx={{ backgroundColor: '#cee2ff', paddingX: 2, paddingY: 1, fontWeight: 600 }}>
              {mainHeaderName}
            </TableCell>
          </TableRow>
          <TableRow>
            {columns.map((row, index) => (
              <TableCell
                sx={{
                  textAlign: row.field === 'action' || row.field === 'actions' ? 'center' : 'left',
                  backgroundColor: '#f0f6ff', 
                  fontFamily: 'Instrument Sans',
                  fontSize: '0.875rem',
                  pt: 1,
                  lineHeight: '1.25rem',
                  fontWeight: 600,
                  color: '#1D1B20',
                  ...row?.customHeaderStyle,
                }}
                width={row?.width ?? 100}
                key={index}
              >
                {row.headerName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody sx={{ borderRadius: 0, border: '0.0625rem solid #ECE9DC' }}>
          {data.map((row, index) => (
            <TableRow key={index}>
              {columns.map((item) => (
                <TableCell
                  key={item.field}
                  sx={{
                    maxWidth: '15.625rem',
                    textAlign: item.alignSelf ? item.alignSelf : 'left',
                    fontFamily: 'Instrument Sans',
                    fontSize: '0.875rem',
                    borderBottom: row.hasBottomBorder ? '0.1rem solid black' : '',
                    lineHeight: '1.25rem',
                    fontWeight: 400,
                    padding: '0.75rem 0.75rem',
                    ...item?.customCellStyle,
                  }}
                >
                  {renderCell ? renderCell(row, item) : row[item.field]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PricingTable;
